export const BUILDING_FORM_INSURANCE_TYPE_API_PARAMS = {
  ordering: 'value',
}
